<template>
  <div class="tw-mx-auto">
    <div class="md:tw-flex">
      <div class="tw-flex-1 tw-grow tw-text-center tw-border-t-2 tw-border-r-2 tw-boder-gray-700">
        <div class="tw-px-4 lg:tw-px-12 tw-py-8 tw-text-left">
          <template v-if="state.loadingProduct">
            <SkeletonLoader class="tw-w-1/3 tw-h-8" />
          </template>
          <template v-else>
            <RouterLink to="/menu" class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2 hover:tw-text-orange-medium">Menu</RouterLink> >
            <template v-if="router.options && router.options.history && router.options.history.state && router.options.history.state.back && router.options.history.state.back == '/menu/categories'">
              <RouterLink 
                :to="{ name: 'all-categories' }"
                class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2 hover:tw-text-orange-medium">
                  All Categories
                </RouterLink> >
            </template>
            <template v-else-if="state.parentCategory">
              <RouterLink 
                :to="{ name: 'category', params: { id:  state.parentCategory.id}}"
                class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2 hover:tw-text-orange-medium">
                  {{state.parentCategory.name}}
                </RouterLink> >
            </template>
            <span v-if="state.product" class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2">{{state.product.name}}</span>
          </template>
        </div>

        <template v-if="state.loadingProduct">
          <SkeletonLoader class="tw-w-full tw-h-96 tw-mb-16" />
          <div class="tw-px-16">
            <SkeletonLoader class="tw-mx-auto tw-w-2/3 tw-h-16 tw-mb-4" />
            <SkeletonLoader class="tw-mx-auto tw-w-full tw-h-6 tw-mb-2" />
            <SkeletonLoader class="tw-mx-auto tw-w-full tw-h-6 tw-mb-2" />
            <SkeletonLoader class="tw-mx-auto tw-w-2/3 tw-h-6 tw-mb-12" />
            <SkeletonLoader class="tw-mx-auto tw-w-1/4 tw-h-16 tw-rounded-full tw-mb-4" />
          </div>
        </template>

        <template v-else>
          <div class="tw-mb-16" v-if="state.product && productHero">
            <img 
              :alt="state.product.name+' image'"
              class="tw-w-full group-hover:tw-scale-125 tw-transition-all tw-duration-300 tw-ease-out"
              :src="productHero">
          </div>
        
          <div class="tw-px-8 tw-mb-0 md:tw-pb-24 lg:tw-pb-32">
            <h2 class="tw-text-6xl tw-font-bold tw-mb-4" v-if="state.product">{{state.product.name}}</h2>
            <div class="tw-text-gray-700 tw-font-bold tw-mb-4">
              <span v-if="state.product && state.product.cost"> ${{currentPrice.toLocaleString("en-US", {minimumFractionDigits: 2})}}</span> <span v-if="state.product && state.product.feeds">| Each Serves {{Math.round(metaFeeds / state.quantity)}}</span>
            </div>
            <p class="tw-mb-16" v-if="state.product && state.product.description">
              {{state.product.description}}
            </p>
            <TwButton 
              cssClass="tw-bg-orange-medium hover:tw-bg-orange-dark tw-border-orange-medium tw-border-2 tw-hidden md:tw-inline-block tw-rounded-full tw-text-white tw-text-2xl tw-uppercase tw-font-bold tw-px-12 tw-mb-4 tw-py-6 tw-transition-all tw-duration-200" 
              @emit-click="addItem" 
              :isLoading="state.addingToBag"
              :isDisabled="false" 
              :buttonText="state.basketProduct != null ? 'Update Item' : 'Add To Order'"/>
          </div>

          <template v-if="state.debug">
            <div class="tw-border-b tw-border-gray-700 tw-py-16">
              <h1>selectedOptions</h1>
              {{state.selectedOptions}}
            </div>
            <div class="tw-border-b tw-border-gray-700 tw-py-16">
              <h1>Included Ingredients</h1>
              {{state.includedIngredients}}
            </div>
            <div class="tw-border-b tw-border-gray-700 tw-py-16">
              <h1>basketProduct</h1>
              {{state.basketProduct}}
            </div>
            <div class="tw-border-b tw-border-gray-700 tw-py-16">
              <h1>Product</h1>
              {{state.product}}
            </div>
          </template>
        </template>
      </div>
      
      <div class="tw-flex-1 tw-grow">
        <div class="tw-max-w-7xl">
          <template v-if="state.loadingProduct">
            <SkeletonLoader class="tw-w-full" />
            <div class="tw-px-16 tw-pt-4 tw-pb-32">
              <SkeletonLoader class="tw-w-2/3 tw-h-16 tw-mb-2" />
              <SkeletonLoader class="tw-w-1/2 tw-h-6 tw-mb-8" />

              <div class="tw-border-b tw-border-gray-700 tw-pb-16 tw-grid tw-gap-8 tw-grid-cols-2 tw-mb-12 ">  
                <SkeletonLoader
                  class="tw-my-1 tw-px-1 tw-h-24 tw-w-full"
                  v-for="idx in 12" 
                  :key="'loader-'+idx" />
              </div>

              <SkeletonLoader class="tw-w-1/3 tw-h-16 tw-mb-2" />
              <SkeletonLoader class="tw-w-1/4 tw-h-6 tw-mb-8" />

              <div class="tw-border-b tw-border-gray-700 tw-pb-16 tw-grid tw-gap-8 tw-grid-cols-2 tw-mb-12 ">  
                <SkeletonLoader
                  class="tw-my-1 tw-px-1 tw-h-24 tw-w-full"
                  v-for="idx in 12" 
                  :key="'loader-'+idx" />
              </div>

            </div>
          </template>

          <template v-else>
            <div v-if="state.product" class="tw-px-8 lg:tw-px-16 tw-pt-4 tw-pb-32">
              
              <OptionGroup 
                v-for="(optionGroup , index) in state.product.optiongroups"
                :class="[{'tw-pt-0 md:tw-mt-24': index == 0}]"
                :key="'og-'+(optionGroup as OptionGroupInterface)!.id"
                :selectedOptions="state.selectedOptions"
                :optionGroup="optionGroup"
                :isFirst="index == 0"
                @optionAdded="selectOption"
                @optionRemoved="removeOption"
              />

              <div class="tw-border-b tw-border-gray-700 tw-py-16">
                <div class="tw-overflow-hidden tw-rounded-lg tw-shadow-lg tw-bg-white tw-w-full tw-block tw-px-8 tw-py-8 tw-mb-16">
                  <div class="lg:tw-flex tw-items-center tw-justify-center tw-text-center">
                    <div class="tw-flex-1 tw-mx-4 tw-mb-6 lg:tw-mb-0">
                      <!-- @vue-skip -->
                       <h4 class="tw-text-3xl tw-mb-2">How many {{pluralizeProductName(state.product.name, 2)}} would you like?</h4>
                        <p class="tw-text-lg" v-if="metaFeeds">
                          (One {{state.product.name}} feeds {{Math.round(metaFeeds / state.quantity)}} people | +${{currentPrice.toFixed(2)}})
                        </p>
                    </div>

                    <div class="tw-flex-1 tw-mx-4 tw-flex tw-justify-center">
                      <div class="tw-flex tw-items-center tw-relative tw-max-w-xs">
                        <input 
                        v-model="state.quantity"
                        min="1"
                        increment="1"
                        class="tw-w-full tw-text-3xl tw-max-w-96 tw-text-center tw-px-16 tw-py-4 tw-border focus:tw-outline-none tw-border-gray-400 focus:tw-border-orange-medium focus:tw-ring-0 tw-rounded-full"
                        type="number">
                        <button
                          @click="decrementQuantity"
                          class="tw-px-8 tw-text-4xl hover:tw-text-orange-medium tw-transition-all tw-font-bold tw-text-black tw-absolute tw-left-0">
                          &mdash;
                        </button>

                        <button
                          @click="incrementQuantity"
                          class="tw-px-8 tw-text-4xl hover:tw-text-orange-medium tw-transition-all tw-font-bold tw-text-black tw-absolute tw-right-0 ">
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <h3 class="tw-text-3xl tw-font-black tw-mb-8">Hunger Meter</h3>
                <div class="tw-mb-4">
                  <ProgressBar 
                    :baseline="baselineCovered"
                    :percentage="percentageAccountedFor" />
                </div>

                <div class="tw-uppercase tw-text-right tw-font-black">
                 {{totalFed}} / {{cateringOrderStore.cateringOrder!.guest_count}} People Fed After Adding This Item
                </div>
              </div>

              <Addons 
                class="tw-border-b tw-border-gray-700 tw-py-16"
                :selectedAddons="state.selectedAddons"
                :addons="state.addons"
                @addonToggled="toggleAddon"
              />

              <div class="tw-mt-16">
                <TwButton 
                  cssClass="tw-bg-orange-medium hover:tw-bg-orange-dark tw-border-orange-medium tw-border-2 tw-rounded-full tw-text-white tw-text-3xl tw-uppercase tw-font-bold tw-px-24 tw-mb-4 tw-py-8  tw-transition-all tw-duration-200" 
                  @emit-click="addItem" 
                  :isLoading="state.addingToBag"
                  :isDisabled="false" 
                  :buttonText="addItemText"/>

              </div>


              <div class="tw-border-t tw-mt-16 tw-border-gray-700 tw-py-16" v-if="false">

                <h3 class="tw-text-3xl tw-font-black tw-mb-8">Allergens</h3>

                <template v-if="currentAllergens">
                  {{currentAllergens}}
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {
    reactive, computed, onMounted, ref, watch
  } from 'vue';
  import { getCurrentInstance } from "vue";
  import { useRoute, useRouter } from 'vue-router';

  // Data
  import { useBasketStore } from '../../stores/basket';
  import { useCateringOrderStore } from '../../stores/catering_order';
  import { useMenuStore } from '../../stores/menu';
  import { useUserStore } from '../../stores/user';
  import { useFlashMessageStore } from '../../stores/flashMessages';

  import Product from '../../classes/Product';
  import type MenuCategory from '../../classes/MenuCategory'
  import type BasketProduct from '../../classes/BasketProduct';
  import type BasketProductChoice from '../../types/BasketProductChoice';
  import { plainToClass } from 'class-transformer';
  import OptionGroup from './_OptionGroup.vue';
  import Addons from './_Addons.vue';
  import type OptionGroupInterface from '../../types/OptionGroup';
  import type OptionInterface from '../../types/Option';
  import type ChoiceCustomField from '../../types/ChoiceCustomField';
  import type FlashMessage from '../../types/FlashMessage';

  import SkeletonLoader from '../../components/SkeletonLoader.vue';
  import TwButton from '../../components/TwButton.vue';
  import ProgressBar from '../../components/ProgressBar.vue';

  const basketStore = useBasketStore();
  const cateringOrderStore = useCateringOrderStore();
  const menuStore = useMenuStore();
  const userStore = useUserStore();
  const flashMessageStore = useFlashMessageStore();
  
  const route = useRoute();
  const router = useRouter();

  const state = reactive({
     product: null as (Product | null),
     basketProduct: null as (BasketProduct | null),
     selectedOptions: new Map<number, number>(),
     includedIngredients: new Map<string, number>(),
     quantity: 1,
     addingToBag: false,
     originalAddons: [] as Product[],
     addons: [] as Product[],
     selectedAddons: [] as Product[],
     loadingProduct: true,
     debug: false,
     parentCategory: undefined as (MenuCategory | undefined), 
   })

  // Runs through the product data and sets up default selection states and flattens as needed

  const initializeProduct = ((product: Product) => {
    let vm = this;
    const prod = product;

    let ogs = [] as OptionGroupInterface[];

    if (product.optiongroups && product.optiongroups.length > 0) {
      product.optiongroups.forEach((og) => {
        const desc = og.description.toLowerCase()
        if (og.description.toLowerCase() == "included ingredients") {
          og.options.forEach((option: OptionInterface) => {
            state.includedIngredients.set(option.name.toLowerCase().replace('no ', ''), option.id)
          });
        }
        // Todo: Map extra proteins to regular

        const fog = flattenedOptionGroup(og);
        const preselectedGroups = preSelectOptionsForGroup(fog);
        ogs = ogs.concat(preselectedGroups);
      })
    }

    if (prod.custom_data && prod.custom_data.addon_products) {
      let prods = JSON.parse(prod.custom_data.addon_products);
      // Loop over the addons and get the full products
      Object.entries(prods).forEach((addonArr: Array<any>) => {
        menuStore.getProductByChainId(addonArr[0]).then((addonProduct: Product) => {
          if (addonProduct) {
            addonProduct.quantity = addonArr[1];
            state.originalAddons.push(addonProduct);
            state.addons.push(addonProduct);
          }
        })
      })
    }

    if (state.basketProduct) {
      prod.optiongroups = preSelectBasketChoices(ogs);
    } else {
      prod.optiongroups = ogs;
    }

    state.product = prod;

    setProductBreadcrumbCategory()

    state.loadingProduct = false;
  })

  const preSelectOptionsForGroup = ((ogs: OptionGroupInterface[]): OptionGroupInterface[] => {
    let isBasketProduct = typeof(route.params.bpid) != undefined;

    ogs.forEach((og) => {
      og.options.forEach((option: OptionInterface) => {
        let shouldSelect = false;
        // Check if the option is a default
        if (!isBasketProduct && option.isdefault && (option.inverseId == null || option.inverseId == undefined)) {
          shouldSelect = true;
        }

        if (shouldSelect) {
          // option.isSelected = true;
          if (!state.selectedOptions.has(option.id)) {
            if (option.quantity) {
              state.selectedOptions.set(option.id, option.quantity);
            } else {
              state.selectedOptions.set(option.id, 1);
            }
          } // Else its already selected?
        }
      })
    })

    return ogs;
  })

  const preSelectBasketChoices = ((ogs: OptionGroupInterface[]): OptionGroupInterface[] => {
    const mappedBasketChoices = state.basketProduct!.choices.map((choice: BasketProductChoice) => {
      return choice.optionid
    })
    // We'll loop over the choices and figure out selections
    ogs.forEach((og: OptionGroupInterface) => {
      if ((og.description.toLowerCase() != "included ingredients") && og.options) {
        og.options.forEach((opt: OptionInterface) => {
          if (mappedBasketChoices.includes(opt.id) || mappedBasketChoices.includes(opt.inverseId) ) {

            // We have to get the exact basket choice to confirm option quantity
            let bpchoice = state.basketProduct!.choices.find((choice: BasketProductChoice) => {
              if (opt.inverseId != null && opt.inverseId != undefined) {
                return choice.optionid == opt.inverseId;
              } else {
                return choice.optionid == opt.id;
              }
            })

            if (bpchoice) {
              if (opt.inverseId != null && opt.inverseId != undefined) {
                opt.isSelected = false;
                opt.quantity = 0;
                if (state.selectedOptions.has(opt.id)) {
                  // Set qty 0 and loop back over to set the basket choice qty
                  state.selectedOptions.set(opt.id, 0)
                } 
                for(let i = 0; i < bpchoice.quantity; i++){
                  selectOption(opt)
                }
              } else {
                opt.isSelected = true;
                opt.quantity = bpchoice.quantity;
                if (state.selectedOptions.has(opt.id)) {
                  // Set qty 0 and loop back over to set the basket choice qty
                  state.selectedOptions.set(opt.id, 0)
                } 

                for(let i = 0; i < bpchoice.quantity; i++){
                  selectOption(opt)
                }
              }
            }
          }
        })
      }
    })

    return ogs
  })

  // Given an option group, will loop through nested options to look for nested option groups
  // Returns an array of all option groups nested under the option group
  const flattenedOptionGroup = ((og: OptionGroupInterface): OptionGroupInterface[] => {
    let isBasketProduct = typeof(route.params.bpid) != undefined;
    let flattenedOgs = [og] as OptionGroupInterface[];
    if (og.options && og.options.length > 0) {
      og.options.forEach((opt: OptionInterface) => {
        if (state.includedIngredients) {
          const isIncluded = state.includedIngredients.has(opt.name.toLowerCase());
          if (isIncluded) {
            opt.isSelected = isIncluded;
            opt.inverseId = state.includedIngredients.get(opt.name.toLowerCase())!
          } else if (!isBasketProduct && opt.isdefault && !isBasketProduct) {
            opt.isSelected = true
          }
        }

        if (opt.optiongroups && opt.optiongroups.length > 0) {
          opt.optiongroups.forEach((og2: OptionGroupInterface) => {
            og2.parentId = opt.id;

            flattenedOgs = flattenedOgs.concat(flattenedOptionGroup(og2));
          })
        }
      })
    }

    return flattenedOgs;
  })

  const selectOption = ((option: OptionInterface) => {
    if (option.inverseId != null || option.inverseId != undefined) {
      if (state.selectedOptions.has(option.inverseId)) {
        state.selectedOptions.set(option.inverseId, (state.selectedOptions.get(option.inverseId)! + 1))
      } else {
        state.selectedOptions.set(option.inverseId, 1)
      }
    } else {
      if (state.selectedOptions.has(option.id)) {
        state.selectedOptions.set(option.id, (state.selectedOptions.get(option.id)! + 1))
      } else {
        state.selectedOptions.set(option.id, 1)
      }
    }

  })

  const removeOption = ((option: OptionInterface) => {
    if (option.inverseId != null || option.inverseId != undefined) {
      if (state.selectedOptions.has(option.inverseId) && state.selectedOptions.get(option.inverseId)! > 1) {
        state.selectedOptions.set(option.inverseId, (state.selectedOptions.get(option.inverseId)! - 1))
      } else {
        state.selectedOptions.delete(option.inverseId);
      }
    } else {
      if (state.selectedOptions.has(option.id) && state.selectedOptions.get(option.id)! > 1) {
        state.selectedOptions.set(option.id, (state.selectedOptions.get(option.id)! - 1))
      } else {
        state.selectedOptions.delete(option.id);
        deselectChildOptions(option);
      }
    }
  })

  const toggleAddon =  ((addon: Product) => {
    const selectedIndex = state.selectedAddons.map(sel => sel.id).indexOf(addon.id);
    if (selectedIndex > -1) {
      const idx = selectedIndex;
      state.selectedAddons.splice(idx, 1);
    } else {
      state.selectedAddons.push(addon)
    }
  })

  const deselectChildOptions = ((option: OptionInterface) => {
    if (option.optiongroups && option.optiongroups.length > 0) {
      option.optiongroups.forEach((og: OptionGroupInterface) => {
        if (og.options && og.options.length > 0) {
          og.options.forEach((opt: OptionInterface) => {
            if (opt.isSelected) {
              if (opt.quantity > 1) {
                for(let i=0; i < opt.quantity; i++) {
                  removeOption(opt);
                }
              } else {
                removeOption(opt);
              }
              opt.isSelected = false;
            }
          })
        }
      })
    }
  })

  const addItem = () => {
    if (state.product) {
      state.addingToBag = true;
      let options = [] as number[];
      let choicecustomfields = [] as ChoiceCustomField[];
      if (state.selectedOptions) {
        // Loop over options to add them with quantities if necessary
        state.selectedOptions.forEach((qty,id) => {
          if (qty > 1) {
            options.push(id);
            choicecustomfields.push({choiceid: id, quantity: qty} as ChoiceCustomField)
          } else {
            options.push(id);
          }
        })
      }

      // We update the basket item
      if (state.basketProduct) {
        basketStore.updateProduct(state.product.id!.toString(), state.basketProduct.id.toString(), state.quantity, "", options, choicecustomfields).then(() => {
          if (state.selectedAddons && state.selectedAddons.length > 0) {
            let addonsAdded = 0;
            state.selectedAddons.forEach((addon: Product) => {
              basketStore.addProduct(addon.id!.toString(), addon.quantity, "", [], [], undefined).then(() => {
                addonsAdded += 1;
                if (addonsAdded == state.selectedAddons.length) {
                  state.addingToBag = false;
                  flashMessageStore.dismissErrors();
                  router.push('/menu')
                }
              })
            })
          } else {
            state.addingToBag = false;
            flashMessageStore.dismissErrors();
            router.push('/menu')
          }
        }).catch((error: Error) => {
          popError(error.message, "Error Adding Item");
          state.addingToBag = false;
        })
      } else {
        // Kick off the product add call, if it succeeds we can try to also add the addon products
        basketStore.addProduct(state.product.id!.toString(), state.quantity, "", options, choicecustomfields, undefined).then(() => {
          if (state.selectedAddons && state.selectedAddons.length > 0) {
            let addonsAdded = 0;
            state.selectedAddons.forEach((addon: Product) => {
              basketStore.addProduct(addon.id!.toString(), addon.quantity, "", [], [], undefined).then(() => {
                addonsAdded += 1;
                if (addonsAdded == state.selectedAddons.length) {
                  completeProductAdd()
                }
              })
            })
            
          } else {
            completeProductAdd()
          }
        }).catch((error: Error) => {
          popError(error.message, "Error Adding Item");
          state.addingToBag = false;
        })
      }
    } else {
      // We have problems
      popError("Item could not be added. Please make sure all required selections have been made and try again.", "Error Adding Item");
      state.addingToBag = false;
    }
  };

  const popError = (error: string, title: string) => {
    const message = {
        id: Math.round(Date.now() / 1000),
        messageType: "danger",
        text: error,
        headline: title,
        delay: 0, // ms
        icon: "",
        cssClass: "",
    } as FlashMessage;
    flashMessageStore.addMessage(message);
  }

  const completeProductAdd = (() => {
    flashMessageStore.dismissErrors();
    const message = {
        id: Math.round(Date.now() / 1000),
        messageType: "success",
        text: "Product has been added to bag",
        headline: "",
        delay: 5000, // ms
        icon: "",
        cssClass: "",
    } as FlashMessage;
    flashMessageStore.addMessage(message);

    state.addingToBag = false;
    router.push('/menu')
  })

  const decrementQuantity = () => {
    state.quantity = Math.max(state.quantity -= 1, 1);
  };

  const incrementQuantity = () => {
    state.quantity = Math.min(state.quantity += 1, 99);
  };

  watch(() => state.quantity, (newQty, oldQty) =>  {
    updateAddonQuantity(newQty);
  })

  const updateAddonQuantity = ((updatedQuantity: number) => {
    let dupedAddons = JSON.parse(JSON.stringify(state.originalAddons)) as Product[]

    dupedAddons.forEach((addon: Product) => {
      addon.quantity = Math.round((addon.quantity * updatedQuantity));
      if (state.selectedAddons) {
        // Check to see if this addon is selected, and up the selected addon to match quantity
        const match = state.selectedAddons.find((selAddon: Product) => {
          return selAddon.id == addon.id
        })

        if (match) {
          match.quantity = addon.quantity;
        }
      }
    })

    state.addons = dupedAddons;
  })

  const setProductBreadcrumbCategory = () => {
    let category = undefined as (MenuCategory | undefined);

    // We'll have to search through the menu to find the category this item is in
    menuStore.menu.forEach((cat: MenuCategory) => {
      if (cat.products && cat.products.length > 0) {
        const matchedProduct = cat.products.find((prod: Product) => {
          return prod.id == state.product!.id;
        })

        if (matchedProduct) {
          category = cat;
        }
      }
    })

    state.parentCategory = category;
  }

  const currentPrice = computed(() => {
    let calculatedCost = 0.00;
    if (state.product) {
      calculatedCost += state.product.cost! as number
    
      // Loop over all the options and get their cost
      state.product!.optiongroups!.forEach((og: OptionGroupInterface) => {
        og.options.forEach((opt: OptionInterface) => {
          if (opt.isSelected) {
            if (opt.cost > 0) {
              calculatedCost += (opt.cost * (opt.quantity > 0 ? opt.quantity : 1));
            }
          }        
        })
      })
    }

    if (state.selectedAddons && state.selectedAddons.length > 0) {
      state.selectedAddons.forEach((addon: Product) => {
        calculatedCost += (addon.cost! as number * addon.quantity);
      })
    }

    return calculatedCost * state.quantity;
  })

  const currentDietary = computed(() => {
   // Loop over current selected options to determine the dietary makeup of the product
    return []
  })

  const currentAllergens = computed(() => {
    let allergens = [] as string[];
   // Loop over current selected options to determine the dietary makeup of the product
    if (state.product!.custom_data) {
      let cd = state.product!.custom_data;
      if (!cd.nut_free) {
        allergens.push('Nuts');
      }
      if (!cd.dairy_free) {
        allergens.push('Dairy');
      }
      if (cd.soy_free) {
        allergens.push('Soy');
      }
    }

    return allergens.join(', ')
  })

  const productHero = computed(() => {
    let img = null

    if (state.product && state.product.images) {
      const imageByKey = state.product.getImageByKey("product_web_block")
      if (imageByKey) {
        img = state!.product!.getImageByKey("product_web_block")!.url
      } else {
        img = 'https://mypiada-assets.s3.amazonaws.com/static_assets/scooter-placeholder.jpg';
      }
    }

    return img
  })

  // Count selected options and how many guests they feed
  const optionsFeed = computed(() => {
    let feeds = 0;
    // TODO: Add this back when the basket can handle options having a feeds property
    // let optionFeedsMap = new Map<number, number>();

    // if (state.product && state.product.optiongroups) {
    //   state.product.optiongroups.forEach((og: OptionGroupInterface) => {
    //     if (og.options && og.options.length > 0) {
    //       og.options.forEach((opt: OptionInterface) => {
    //         if (opt.feeds && opt.feeds != 0 && opt.isSelected) {
    //           if (opt.quantity && opt.quantity > 1) {
    //             feeds += Math.round((opt.feeds * opt.quantity))
    //           } else {
    //             feeds += opt.feeds
    //           }
    //         }
    //       })
    //     }
    //   })
    // }

    return feeds;
  })

  const metaFeeds = computed(() => {
    let feeds = 0

    let count = 0;
    let lightFeeds = 0;
    let regularFeeds = 0;
    let hungryFeeds = 0;
    let lightPct = 0;
    let regularPct = 0;
    let hungryPct = 0;
    let totalGuests = 0;

    if (cateringOrderStore.cateringOrder) {
      totalGuests = cateringOrderStore.cateringOrder.guest_count;
    }

    // console.log(guestHungerArray.value, totalGuests);

    if (totalGuests && totalGuests > 0) {
      lightPct = (guestHungerArray.value.at(0)!) / totalGuests;
      regularPct = (guestHungerArray.value.at(1)!) / totalGuests;
      hungryPct = (guestHungerArray.value.at(2)!) / totalGuests;
    }

    // console.log('percents', lightPct, regularPct, hungryPct);


    if (state.product && state.product.feeds) {
      lightFeeds += (state.product.feeds.at(0)!);
      regularFeeds += (state.product.feeds.at(1)!);
      hungryFeeds += (state.product.feeds.at(2)!);
    }

    // console.log('feeds count', lightFeeds, regularFeeds, hungryFeeds)

    let feedsLight = lightFeeds * lightPct;
    let feedsRegular = regularFeeds * regularPct;
    let feedsHungry = hungryFeeds * hungryPct;

    // console.log(feedsLight, feedsRegular, feedsHungry, " = ", (feedsLight + feedsRegular + feedsHungry));

    let feedsAmount = Math.round(feedsLight + feedsRegular + feedsHungry);
    count += feedsAmount * state.quantity;

    return count;
  })

  const guestHungerArray = computed(() => {
    if (cateringOrderStore.cateringOrder) {
      return [cateringOrderStore.cateringOrder!.light_eaters, cateringOrderStore.cateringOrder!.regular_eaters, cateringOrderStore.cateringOrder!.hungry_eaters];
    } else {
      return [0,0,0];
    }
  })

  const baselineCovered = computed(() => {
    if (cateringOrderStore.cateringOrder!.guest_count && basketStore.basket) {
      let currentlyFeeds = basketStore.basket.basketFeeds(guestHungerArray.value, cateringOrderStore.cateringOrder!.guest_count, undefined);

      if (route.params.bpid && typeof(route.params.bpid) == 'string') {
        const bpid: string = route.params.bpid;
        currentlyFeeds = basketStore.basket.basketFeeds(guestHungerArray.value, cateringOrderStore.cateringOrder!.guest_count, bpid);
      }

      return Math.min(((currentlyFeeds/cateringOrderStore.cateringOrder!.guest_count)*100), 100);
    } else {
      return 0;
    }
  })

  const percentageAccountedFor = computed(() => {
    if (metaFeeds.value && cateringOrderStore.cateringOrder!.guest_count) {
      return Math.min(((metaFeeds.value/cateringOrderStore.cateringOrder!.guest_count)*100), 100);
    } else {
      return 0;
    }
  })

  const totalFed = computed(() => {
    let count = 0;
    let baskFeeds = null;
    if (basketStore.basket) {

      if (route.params.bpid) {
        baskFeeds = basketStore.basket!.basketFeeds(guestHungerArray.value, cateringOrderStore.cateringOrder!.guest_count, route.params.bpid!.toString());
      } else {
        baskFeeds = basketStore.basket!.basketFeeds(guestHungerArray.value, cateringOrderStore.cateringOrder!.guest_count, undefined);
      }
    }

    if (metaFeeds) {
      count += metaFeeds.value!
    }
    
    if (baskFeeds) {
      count += baskFeeds
    }

    return count;
  })

  const beginCustomizeView = (() => {
    if (route.params.bpid) {
      let basketProduct = undefined as (BasketProduct | undefined);

      if (route.params.bpid) {
        if (basketStore.basket && basketStore.basket.products) {
           basketProduct = basketStore.basket!.products.find((bp: BasketProduct) => {
            return bp.id.toString() == route.params.bpid;
          })
        } else {
          // Try to get the basket again
          basketStore.fetchBasketWithPromise(localStorage.getItem('mypiadaBasketId')!).then(() => {
            basketProduct = basketStore.basket!.products.find((bp: BasketProduct) => {
              return bp.id.toString() == route.params.bpid;
            })
          });
        }
      }

      if (basketProduct) {
        state.basketProduct = basketProduct as BasketProduct;
        state.quantity = state.basketProduct.quantity
      }
    }
  
    menuStore.getProduct(parseFloat(route.params.id.toString())).then((product: Product) => {
      initializeProduct(plainToClass(Product, (product as object)) as Product)
    }) // menuStore.fetchProduct(parseFloat(route.params.id.toString()))
  })

  const addItemText = computed(() => {
    let txt = state.basketProduct != null ? 'Update Item' : 'Add To Order';
    if (state.product && state.product.cost) {
      txt += ' - $' + (currentPrice.value.toLocaleString("en-US", {minimumFractionDigits: 2}));
    }
    return txt;
  })

  onMounted(() => {
    // Make sure we have a menu first
    if (userStore.userLocation) {
      if (menuStore.menu && menuStore.menuLocation) {
        beginCustomizeView()
      } else {
        menuStore.fetchMenu(parseFloat(userStore.userLocation.extref)).then(() => {
          beginCustomizeView()
        })
      }
    } else {
      const message = {
        id: Math.round(Date.now() / 1000),
        messageType: "danger",
        text: "You must select a location",
        headline: "Error",
        delay: 0, // ms
        icon: "",
        cssClass: "",
      } as FlashMessage;
      flashMessageStore.addMessage(message);
      router.push('wizard');
    }
  })

</script>

<style>
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button,
input[type='number'] {
  -webkit-appearance: none;
  margin: 0;
  -moz-appearance: textfield !important;
}
</style>